import React from "react";
import { ErrorLayout } from "./ErrorLayout";
import TEXT from "./TEXT";
import { RenderApp } from "../common/components/RenderApp";
import { P } from "../common/components/p";

const errorText = TEXT.ikkePameldtError;

RenderApp(
	<ErrorLayout tittel={errorText.tittel}>
		<P>{errorText.content}</P>
	</ErrorLayout>
);
